// Loaded on every page, on the website and in the apps' WebView. The page-specific bundles are loaded after it.

import {initAnalytics} from './app/analytics.ts'
import {addCountUpAnimations, addFadeAnimations} from './app/animations.ts'
import {markDownloadProductCards, populateToc, removeLoadersOfLoadedImages, removeShadowOfBorderlessImages} from './app/articles.ts'
import {initCookieBanner} from './app/consent.ts'
import {initDownloadCta} from './app/download-cta.ts'
import {setLinkTargets} from './app/links.ts'
import {addMasonryLayouts} from './app/masonry.ts'
import {initMobileNav} from './app/mobile-nav.ts'
import {initSupportButtons} from './app/support.ts'
import {initThemeSwitch} from './app/theme-switch.ts'
import {applyVisibilityClasses} from './app/visibility.ts'
import {scrollToHash} from './lib/dom.ts'

/** Runs the features in this order, each on its own, so an error in one (e.g. due to unexpected post content) doesn't stop the others */
const FEATURES = [
    initAnalytics,
    initCookieBanner,
    initSupportButtons,
    applyVisibilityClasses,
    setLinkTargets,
    initMobileNav,
    populateToc,
    markDownloadProductCards,
    removeShadowOfBorderlessImages,
    removeLoadersOfLoadedImages,
    initThemeSwitch,
    initDownloadCta,
    addFadeAnimations,
    addCountUpAnimations,
    addMasonryLayouts,
    resetScrollOnSafari,
]
for (const feature of FEATURES) {
    try {
        feature()
    } catch (error) {
        console.error(error)
    }
}

/**
 * HACK: Safari can't handle it if content changes whilst the page is being loaded, and it needs to scroll to a #. This resets the scroll once the
 * page has loaded (DOMContentLoaded is too early). It is required since we heavily rely on hide/show logic and probably can't get rid of it.
 */
function resetScrollOnSafari() {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    if (isSafari) addEventListener('load', scrollToHash)
}
